import script from "./Menu.vue?vue&type=script&setup=true&lang=js"
export * from "./Menu.vue?vue&type=script&setup=true&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=ba65d288&lang=scss"
import "./Menu.vue?vue&type=style&index=1&id=ba65d288&lang=scss"

const __exports__ = script;

export default __exports__